exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".logistics h3[data-v-396656b0]:after{content:\" \";width:14px;height:6px;background-color:#f56c6c;display:block;margin:12px 0 20px}.logistics h4[data-v-396656b0]{font-size:15px;color:#123;font-weight:600;margin-top:20px;margin-bottom:1px}.logistics p[data-v-396656b0]{font-size:14px;color:#231f20;padding:5px 0;margin:7px 0 0}.logistics .c-t[data-v-396656b0]{margin:30px 0 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-396656b0","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/logistics.vue
// module id = 170
// module chunks = 1